 import firebase from 'firebase'
 import Cookies from 'js-cookie'
 import * as memberActions from './member'
 import {
     getShippingCartList,
     getInboundOrderList
 } from './asyncOrders'
 import ApiWrapper from '../api/cellWineApi'
 import {
     facebookLoginAPI,
     googleLoginAPI,
     signInWithEmailAndPasswordAPI,
     createUserWithEmailAndPasswordAPI,
     firebaseLogout,
     sendResetPasswordEmail,
     encryptHash,
     decryptHash
 } from '../libraries/utils'

 export const checkLogin = () => {
     return async (dispatch) => {
         let user = await firebase.auth().currentUser
         let isRegister = Cookies.get('register')
         if (isRegister) {
             if (user) {
                 dispatch(postRegister(user))
             }

             return
         }
         let api = new ApiWrapper(dispatch, memberActions.loginFailure)
         dispatch(memberActions.loginReq())

         if (user) {
             const token = await user.getIdToken()
             console.log('checkLogin & postLogin')
             console.log('> current user is', user.displayName)
             dispatch(postLogin(token, user.uid))
         } else {
             console.log('checkLogin & loginFailure')
             dispatch(memberActions.loginFailure())
         }
     }
 }

 export const postLogin = (token, uid) => {
     return async (dispatch) => {
         let api = new ApiWrapper(dispatch, memberActions.loginFailure)
         dispatch(memberActions.loginSuccess())
         Cookies.set('token', token)
         Cookies.set('memberSha', uid)
         dispatch(getMemberInfo())
        //  Cookies.remove('redirecting')
     }
 }

 export const postRegister = (user) => {
     return async (dispatch) => {
         try {
             const token = await user.getIdToken()
             Cookies.set('token', token)
             Cookies.set('memberSha', user.uid)

             let api = new ApiWrapper(dispatch, memberActions.registerFailure)
             let member = await api.createMember(user.uid, user.email, user.displayName)
             Cookies.set('memberId', member.id)
             dispatch(postLogin(token, user.uid))
             Cookies.remove('register')
         } catch (e) {
             console.log(`register error: ${e}`)
             dispatch(memberActions.registerFailure({
                 error: e.message
             }))
         }
     }
 }

 export const getMemberInfo = () => {
     return async (dispatch) => {
         let api = new ApiWrapper(dispatch, memberActions.getMemberInfoFailure)
         console.log('* getMemberInfo')
         dispatch(memberActions.getMemberInfoReq())
         let member = await api.getMemberInfo()
         Cookies.set('memberId', member.id)
         let currencyList = await api.getCurrencyList()
         if (currencyList) {
             member.currencyList = currencyList.currencies
         }
         console.log('* getMemberInfo succ')
         dispatch(memberActions.getMemberInfoSuccess(member))
         dispatch(getShippingCartList())
         dispatch(getInboundOrderList(1, 100))
     }
 }

 export const login = (loginType, data, needLogout) => {
     return async (dispatch) => {
         dispatch(memberActions.loginReq())
         let user
         try {
             // firebase
             switch (loginType) {
                 case 'facebook':
                     user = await facebookLoginAPI()
                     break
                 case 'google':
                     user = await googleLoginAPI()
                     break
                 case 'email':
                     user = await signInWithEmailAndPasswordAPI(data)
                     break
                 default:
                     throw new Error('unknown login type.')
             }
         } catch (e) {
             alert('login error', e.message)
             dispatch(memberActions.loginFailure())
             if (needLogout) {
                 dispatch(logout())
             }
         }
     }
 }

 export const logout = () => {
     return async (dispatch) => {
         let api = new ApiWrapper(dispatch, memberActions.logOutFailure)
         dispatch(memberActions.logOutReq())
         await firebaseLogout()
         Cookies.remove('token')
         Cookies.remove('memberSha')
         Cookies.remove('memberId')
         window.location = window.location.origin
         dispatch(memberActions.logOutSuccess())
     }
 }

 export const register = (registerType, data) => {
     return async (dispatch) => {
         Cookies.set('register', true)
         let user
         try {
             // firebase
             switch (registerType) {
                 case 'facebook':
                     user = await facebookLoginAPI()
                     break
                 case 'google':
                     user = await googleLoginAPI()
                     break
                 case 'email':
                     user = await createUserWithEmailAndPasswordAPI(data)
                     break
                 default:
                     throw new Error('unknown register type.')
             }
         } catch (e) {
             console.log(`register error: ${e}`)
             dispatch(memberActions.registerFailure({
                 error: e.message
             }))
         }
     }
 }

 // "cardNo": "4000221111111111",
 // 	"cardExp": "2410",
 // 	"cardCvc": "992"
 export const updateCreditCardSetting = ({
     cardNo,
     cardExp,
     cardCvc
 }) => {
     return async (dispatch) => {
         let api = new ApiWrapper(dispatch, memberActions.updateCreditCardFailure)
         dispatch(memberActions.updateCreditCardReq())
         await api.updateCreditCardSetting({
             cardNo,
             cardExp,
             cardCvc
         })
         dispatch(memberActions.updateCreditCardSuccess())
         dispatch(getMemberInfo())
     }
 }

 export const sendPhoneVerificationCode = (phone) => {
     return async (dispatch) => {
         let api = new ApiWrapper(dispatch, memberActions.sendVerificationCodeFailure)
         dispatch(memberActions.sendVerificationCodeReq())
         await api.sendPhoneVerificationCode(phone)
         dispatch(memberActions.sendVerificationCodeSuccess())
     }
 }

 export const verifyPhoneNumber = (phone, code) => {
     return async (dispatch) => {
         let api = new ApiWrapper(dispatch, memberActions.verifyPhoneNumberFailure)
         dispatch(memberActions.verifyPhoneNumberReq())
         await api.verifyPhoneNumberVerificationCode(phone, code)
         dispatch(getMemberInfo())
         dispatch(memberActions.verifyPhoneNumberSuccess())
     }
 }

 export const updateMemberInfo = (memberInfo) => {
     return async (dispatch) => {
         let api = new ApiWrapper(dispatch, memberActions.updateMemberInfoFailure)
         dispatch(memberActions.updateMemberInfoReq())
         let member = await api.updateMemberInfo(memberInfo)
         dispatch(getMemberInfo())
     }
 }
